import { useReferencesContext } from '../../contexts/ReferencesContext/hooks/useReferencesContext.hook';

import { UsersListForAStatus } from './ListForAStatus';

export const DisabledUsersTabPanel = () => {
  const { genericStatusesCodeMap } = useReferencesContext();

  return <UsersListForAStatus statusId={genericStatusesCodeMap.Disabled._id} />;
};
